const AVATAR_COLORS = [
  '#1d4ed8',
  '#047857',
  '#b45309',
  '#be123c',
  '#6d28d9',
  '#0f766e',
  '#c2410c',
  '#334155',
];

/**
 * Initials from a display name (MafertApp InvolvedUsers parity).
 * @param {string|null|undefined} name
 * @returns {string}
 */
export function supportUserInitials(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ''}${parts[parts.length - 1][0] || ''}`.toUpperCase();
}

/**
 * Deterministic avatar background from a seed string.
 * @param {string|number|null|undefined} seed
 * @returns {string}
 */
export function supportUserAvatarColor(seed) {
  const raw = String(seed || 'user');
  let hash = 0;
  for (let i = 0; i < raw.length; i += 1) {
    hash = ((hash << 5) - hash) + raw.charCodeAt(i);
    hash |= 0;
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

/**
 * Normalize watcher/mention rows from ticket or watchers API.
 * @param {object} row
 * @returns {{ id: number|string, name: string, email?: string, avatarUrl?: string|null }}
 */
export function normalizeSupportInterestedUser(row) {
  const user = row?.user || row;
  const id = user?.id ?? row?.user_id ?? row?.id;
  const name = user?.name || row?.name || row?.email || user?.email || '';
  const email = user?.email || row?.email || undefined;
  const avatarUrl = user?.avatar_url || user?.avatar || row?.avatar_url || null;
  return { id, name, email, avatarUrl };
}
